export default __webpack_public_path__ + "static/media/kitMain.91274cb4.png";